import React,{Component} from 'react';
import {ListItem,List,TextField,Paper,Button,
    Typography,Dialog,DialogActions,DialogContent} from '@material-ui/core';
import DBHandler from '../DBHandler';
import AddIcon from '@material-ui/icons/Add';


let URLBASE = 'usuarios/';


export default class Listado extends Component{

    constructor(props){
        super(props);
        this.state = {
            actual:'',
            filtro:'',
            preFiltro:'',
            listado:[],
            habilitarEdicion:false,
            usuario:props.usuario
        }
        
        this.cargarUsuarios = this.cargarUsuarios.bind(this);
        this.actualizarUsuarios = this.actualizarUsuarios.bind(this);

        this.db = new DBHandler();
        this.pedirUsuarios.bind(this)();

    }

    pedirUsuarios(){
        this.db.enviarPeticion(
            this.cargarUsuarios.bind(this),
            URLBASE + 'listaEmpleados',
            'POST',
            {
                usuario:this.state.usuario
            }
        )
    }

    actualizarUsuarios(){
        this.pedirUsuarios.bind(this)();
    }

    cargarUsuarios(datos){
        this.setState({listado:datos,actual:'',habilitarEdicion:false})
    }

    funcionEnter(ev){
        if(ev.key==='Enter'){
            this.setState({
                filtro:this.state.preFiltro
            });
            ev.preventDefault();
        }
    }

    render(){

        let lista = <ListItem dense={true}>
            <span>
                No hay Usuarios Registrados.
            </span>
        </ListItem>
        let limite = 0;
        if(this.state.listado.length > 0){
            lista = this.state.listado.map((elem,index)=>{
                if(elem.usuario.includes(this.state.filtro) && limite < 200){
                    limite += 1;
                    return <Paper style={{width:'15vw',minWidth:'150px',height:'40px',
                    display:'inline-block',textAlign:'center',margin:'3px'}} 
                        onClick={()=>this.setState({actual:elem.usuario,habilitarEdicion:true})}>
                        <Typography>{elem.usuario}</Typography>
                    </Paper>
                }
            })
        }

        /*if(this.state.listado.length > 0){
            lista = this.state.listado.map((elem,index)=>{
            if(elem.usuario.includes(this.state.filtro)){
                return <ListItem key={index}
                onClick={()=>this.setState({actual:elem.usuario})}>
                    <span style={{textAlign:'right'}} >{elem.usuario}</span>
                </ListItem>}
            })
        }*/
        let edicion = null
        if(this.state.habilitarEdicion){
            edicion = <EditarUsuario cerrar={()=>this.setState({habilitarEdicion:false})}
            actualizarLista = {this.actualizarUsuarios} usuario={this.state.actual}/>
        }

        let tam = window.innerHeight - 140;

        return (
            <div style={{margin:'5px',textAlign:'center'}}>
                <div style={{display:'inline-block'}}>
                    <div style={{marginLeft:'5px'}}>
                        <TextField value={this.state.preFiltro}
                        label='Filtro'
                        onChange = {(ev)=>this.setState({preFiltro:ev.target.value})}
                        onKeyPress = {this.funcionEnter.bind(this)}
                        style={{width:'100px'}}
                        />

                        <Button variant='fab' mini={true}
                        color='primary'
                        style={{position:'relative',left:'10px'}}
                        onClick={()=>this.setState({
                            actual:'',
                            habilitarEdicion:true,
                        })}
                        aria-label='add'
                        >
                            <AddIcon/>
                        </Button>

                    </div>
                    <div style={{height:tam,overflowY:'auto',width:'80vw',marginTop:'5px'}}>
                        {lista}
                    </div>
                </div>
                <div style={{display:'inline-block',verticalAlign:'top',marginLeft:'10px'}}>
                    {edicion}
                </div>
            </div>
        )
    }
}



class EditarUsuario extends Component{
    constructor(props){

        super(props);


        let editaUsuario = true;
        if(props.usuario !== '' ){
            editaUsuario = false;
        }

        this.state={
            usuario:props.usuario,
            pass:'',
            passViejo:'',
            numero:'',
            mail:'',
            editaUsuario:editaUsuario,
            usuarioDisponible:true,
            textoError:'',
            textoOk:'Proveedor',
            nombre:'',
        }

        this.actualizarUsuarios = props.actualizarLista

        this.enviarUsuario = this.enviarUsuario.bind(this);
        this.cargarUsuario = this.cargarUsuario.bind(this);
        this.db = new DBHandler();


        this.cerrar = props.cerrar;

        if(props.usuario !== ''){
            this.pedirUsuario.bind(this);
        }

    }


    pedirUsuario(){
        this.db.enviarPeticion(
            this.cargarUsuario.bind(this),
            URLBASE + 'devolverUsuario',
            'POST',
            {
                usuario:this.state.usuario
            }
        )
    }

    componentWillReceiveProps(props){
        let editaUsuario = true;
        if(props.usuario !== '' ){
            editaUsuario = false;
        }
        
        
        this.setState({
            usuario:props.usuario,
            pass:'',
            passViejo:'',
            numero:'',
            mail:'',
            editaUsuario:editaUsuario,
            usuarioDisponible:true,
            textoError:'',
            textoOk:'Proveedor',
            nombre:'',
        })

        this.cerrar = props.cerrar;

        if(props.usuario !== ''){
            this.pedirUsuario.bind(this);
        }
    }



    cargarUsuario(usuario){
        this.setState({
            usuario:usuario.usuario,
            passViejo:usuario.pass,
            numero:usuario.numero,
            mail:usuario.mail,
            nombre:usuario.nombre,
        })
    }

    enviarUsuario(){
        if(this.state.usuario.replace(' ','').length === 0 
        || this.state.pass.length === 0){
            return
        }

        if(this.state.editaUsuario){
            this.db.enviarPeticion(
                this.actualizarUsuarios,
                URLBASE + 'crearUsuario',
                'POST',
                {
                    usuario:this.state.usuario,
                    pass:this.state.pass,
                    numero:this.state.numero,
                    mail:this.state.mail
                })
        }
        else{

            if(this.state.usuario !== '' && this.state.pass !== ''
            && this.state.usuarioDisponible ){
                this.db.enviarPeticion(this.cerrar,
                    URLBASE + 'editarUsuario',
                    'POST',
                    {
                        usuario:this.state.usuario,
                        pass:this.state.pass,
                        numero:this.state.numero,
                        mail:this.state.mail
                    }
                    )
            }
        }
    }

    limpiarBorrado(){
        let editaUsuario = true;
        
        this.setState({
            usuario:'',
            pass:'',
            passViejo:'',
            numero:'',
            mail:'',
            editaUsuario:editaUsuario,
            usuarioDisponible:true,
            textoError:'',
            textoOk:'Proveedor',
            nombre:'',
        },this.actualizarUsuarios)

    }

    borrarUsuario(){
        this.db.enviarPeticion(this.limpiarBorrado.bind(this),
            URLBASE + 'borrarUsuario',
            'POST',
            {usuario:this.state.usuario})
    }

    render(){

        let textoBoton = null;
        let botonBorrar = null;
        if(this.state.editaUsuario){
            textoBoton = 'Crear';
        }
        else if(!this.state.editaUsuario ){
            textoBoton = 'Actualizar';
            botonBorrar = <Button onClick={this.borrarUsuario.bind(this)}
                                color='secondary'
                                variant='contained'
                            >Borrar</Button>
        }

        



        let error = false;
        let textoError = ''
        if(this.state.textoError.length > 0){
            error = 1;
            textoError = this.state.textoError
        }

        return(
            <Dialog onClose={this.cerrar} open={true} onEscapeKeyDown={this.cerrar}
            onBackdropClick={this.cerrar} >
                <DialogContent>
                    <div style={{marginLeft:'5px'}} >
                        <TextField 
                        type='number'
                        label={this.state.textoOk === 'Proveedor' ? this.state.nombre === '' ? this.state.textoOk:this.state.nombre : this.state.textoOk}
                        value={this.state.usuario}
                        onBlur={()=>{
                            if(this.state.usuario.replace(' ','').length === 0 ){
                                return;
                            }
                            this.db.enviarPeticion((datos)=>{
                                if('error' in datos){
                                    this.setState({usuarioDisponible:false,
                                    textoError:datos['error']})
                                    return;
                                }
                                this.setState({usuarioDisponible:true,
                                    textoOk:datos['ok']});
                            },
                            URLBASE + 'corroborarUsuario',
                            'POST',
                            {usuario:this.state.usuario})
                            }
                        }
                        error={error}
                        helperText={textoError}
                        onChange = {(ev)=>this.setState({usuario:ev.target.value,
                            textoError:'',textoOk:'Proveedor'})}
                        disabled={!this.state.editaUsuario}
                        />
                        <TextField
                        type='password'
                        label='Contraseña'
                        value={this.state.pass}
                        onChange={(ev)=>this.setState({
                            pass:ev.target.value
                        })}
                        /> <br/>
                        <TextField 
                        label='Telefono'
                        value={this.state.numero}
                        onChange={(ev)=>this.setState({
                            numero:ev.target.value
                        })} />
                        <TextField
                            label='Mail'
                            value={this.state.mail}
                            onChange={(ev)=>this.setState({
                                mail:ev.target.value
                            })}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    {botonBorrar}
                    <Button onClick={this.enviarUsuario}
                        color='primary'
                        variant='contained'
                        >
                        {textoBoton}
                        </Button>
                </DialogActions>
            </Dialog>
        )
    }
}